import 'css-chunk:src/LogoArea/LogoArea.module.scss';export default {
  "header_logo_area": "header_logo_area__unegH"
};